import { equipmentFeatures } from "@/mocks/serviceVentaData";

export default function WhyChoose() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div className="reveal">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-[#0087a4] mb-6 leading-tight">
              ¿Por Qué Elegirnos?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
              En <span className="text-[#0087a4] font-semibold">SERIN INGENIERÍA DE PROYECTOS SAS</span>, nos diferenciamos por nuestra capacidad de ofrecer soluciones integrales, adaptadas a las necesidades específicas de cada cliente.
            </p>

            <ul className="space-y-4">
              {equipmentFeatures.map((feature, i) => (
                <li
                  key={feature.title}
                  className="reveal flex items-start gap-3"
                  style={{ transitionDelay: `${i * 80}ms` }}
                >
                  <div className="w-5 h-5 rounded-full bg-[#0087a4] flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-background-50 text-xs" />
                  </div>
                  <div>
                    <span className="text-foreground-800 text-sm md:text-base font-medium">{feature.title}</span>
                    <p className="text-foreground-500 text-xs md:text-sm leading-relaxed mt-0.5">{feature.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="reveal relative h-[400px] md:h-[500px] lg:h-[580px] rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20white%20ceiling%20cassette%20air%20conditioning%20unit%20installed%20in%20contemporary%20office%20ceiling%2C%20clean%20square%20panel%2C%20elegant%20commercial%20interior%2C%20bright%20even%20lighting%2C%20professional%20architectural%20photography%2C%20neutral%20earth%20tones%2C%20energy%20efficient%20HVAC%20system%2C%20close-up%20detail%20shot&width=600&height=800&seq=venta-whychoose-1&orientation=portrait"
              alt="Equipo de climatización cassette"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}